{
  "title": "Guía de tallas",
  "runsSmallLabel": "Talla pequeña",
  "trueToSizeLabel": "Talla normal",
  "runsLargeLabel": "Talla grande",
  "confidenceText": "{value}% de confianza basado en opiniones reales de clientes",
  "loading": "Cargando guía de tallas...",
  "fitCategorySmall": "Probablemente talla pequeña",
  "fitCategoryTrue": "Talla normal",
  "fitCategoryLarge": "Probablemente talla grande",
  "fallbackTruePill": "Probablemente talla normal",
  "noDataPill": "Sin datos disponibles",
  "errorPill": "Temporalmente no disponible",
  "recommendationHeadingSmall": "Considere una talla más grande",
  "recommendationHeadingTrue": "Debería ajustar como se espera",
  "recommendationHeadingLarge": "Considere una talla más pequeña",
  "fallbackTrueHeading": "Debería ajustar como se espera",
  "fallbackTrueSummary": "Aún no tenemos suficientes opiniones de clientes para este artículo, por lo que esta vista asume un ajuste normal.",
  "noDataHeading": "Sin datos disponibles",
  "noDataSummary": "Aún no tenemos suficientes opiniones de clientes para este artículo.",
  "errorHeading": "Guía de tallas no disponible",
  "errorSummary": "Esta recomendación de talla no está disponible temporalmente. Inténtelo de nuevo más tarde.",
  "fallbackSummarySmall": "Las opiniones de los clientes sugieren que este artículo podría ser más pequeño de lo esperado.",
  "fallbackSummaryTrue": "Las opiniones de los clientes sugieren que este artículo debería ajustar como se espera.",
  "fallbackSummaryLarge": "Las opiniones de los clientes sugieren que este artículo podría ser más grande de lo esperado."
}